interface ApiRoutes {
  index: string
  indexHome: string
  pagesHome: string
  topupEntry: string
  billEntry: string
  setDeviceId: string
  deeplink: string
  pwaLogin: string
  pwaValidateToken: string
  pwaLogout: string
  apiLogout: string
  validatePwaPin: string,
  resetPinInit: string,
  resetPin: string,
  helpAndSupport: string,
  settings: string,
  recurring: string,
  loyalty: string,
  loyaltyTerms: string,
  billingAddress: string,
  paymentBillWalletEntry: string,
  preloadSearch: string,
  ssmData: string
}

export const apiRoutes: ApiRoutes = {
  index: '/api/index',
  indexHome: '/api/index/home',
  pagesHome: '/api/pages/home',
  topupEntry: '/payment/topup/entry',
  billEntry: '/payment/bill/entry',
  setDeviceId: '/api/notifications/set-device-id',
  deeplink: '/api/deeplink',
  pwaLogin: '/api/pwa/login/init',
  pwaValidateToken: '/api/pwa/login/validate-temp-token',
  pwaLogout: '/api/pwa/logout',
  apiLogout: '/api/services/logout',
  validatePwaPin: '/api/pwa/services/validate-pin',
  resetPinInit: '/api/pwa/reset-pin/init',
  resetPin: '/api/pwa/reset-pin',
  helpAndSupport: '/api/pages/help-support',
  settings: '/api/pages/settings',
  recurring: '/bill/recurring-payment',
  loyalty: '/web/controller/loyalty',
  loyaltyTerms: '/web/controller/loyalty/terms-accept',
  billingAddress: '/web/billing-address/form',
  paymentBillWalletEntry: '/payment/bill/wallet-entry',
  preloadSearch: '/api/search',
  ssmData: '/api/self-service-menu'
}
